const bailoutCodes = {
    PART_NOT_FOUND: 18,
};

export { bailoutCodes };
